import { createAction, props } from "@ngrx/store";

export const loginSuccess = createAction(
  '[Login Page API] Login Success',
  props<{ loggedUserId: string, token: string, error: string | null }>()
);

export const loginFailed = createAction(
  '[Login Page API] Login Failed',
  props<{ error: string }>()
);

// O Bifrost respondeu { mfaRequired: true, mfaToken }
export const mfaRequired = createAction(
  '[Login Page API] MFA Required',
  props<{ mfaToken: string }>()
);

// O mfaToken expirou (5 min) ou já foi usado (BFT012): volta para usuário e senha
export const mfaTokenExpired = createAction(
  '[Login Page API] MFA Token Expired'
);
